import { useState, forwardRef } from 'react'
import { Button, ButtonProps, Popover, Text, TextField } from '@radix-ui/themes'
import { DateTime } from 'luxon'
import { LuCalendar } from 'react-icons/lu'
import { Calendar } from '~/components/Calendar'
import { usrIsMobileScreenSize } from '~/hooks/usrIsMobileScreenSize'

interface DatePickerFieldProps {
  value: Date
  onChange: (date: Date) => void
  id?: string
  disabled?: boolean
  size?: ButtonProps['size']
  className?: string
}

const DatePickerField = forwardRef<HTMLDivElement, DatePickerFieldProps>(
  ({ value, onChange, id, disabled = false, size, className }, ref) => {
    const [isOpen, setIsOpen] = useState(false)

    const isMobile = usrIsMobileScreenSize()

    const handleDaySelect = (day: Date | undefined) => {
      if (day) {
        onChange(day)
        setIsOpen(false)
      }
    }

    const formattedDate = value ? DateTime.fromJSDate(value).toFormat('dd/MM/yyyy') : 'Sélectionner une date'

    if (isMobile) {
      return (
        <TextField.Root
          className={className}
          // @ts-ignore
          size={size}
          type="date"
          value={DateTime.fromJSDate(value).toISODate() ?? undefined}
          max={DateTime.now().toISODate()}
          onChange={(e) => {
            const dateValue = e.target.valueAsDate
            if (dateValue) {
              onChange(dateValue)
            }
          }}
        />
      )
    }

    return (
      <div ref={ref} className={className}>
        <Popover.Root open={isOpen} onOpenChange={setIsOpen}>
          <Popover.Trigger>
            <Button variant="surface" color="gray" size={size} className="w-full" id={id} disabled={disabled}>
              <Text className="text-black dark:text-white mr-auto" weight={'regular'}>
                {formattedDate}
              </Text>
              <LuCalendar className="ml-auto" />
            </Button>
          </Popover.Trigger>

          <Popover.Content className="!min-w-0">
            <Calendar
              defaultMonth={value}
              mode="single"
              numberOfMonths={1}
              selected={value}
              onSelect={handleDaySelect}
              enableYearNavigation
            />
          </Popover.Content>
        </Popover.Root>
      </div>
    )
  }
)

DatePickerField.displayName = 'DatePickerField'

export default DatePickerField
